import { type IDropOptions, type IInboxTreeCombine } from 'entities/Inbox'
import { SmartView } from 'entities/SmartViews/model/SmartView'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

export const actionMoveToDragDrop = async (
  options: IDropOptions<IInboxTreeCombine>,
  dropRoot: string | number,
  store: ConversationMenuStore
) => {
  const { dropTargetId, dragSourceId, dropTarget, dragSource } = options

  const isChild = (child: string | number | undefined) => {
    if (!child) return false

    const strChild = child.toString()
    const strRoot = dropRoot.toString()

    return strChild === strRoot || strChild.includes(strRoot)
  }

  const realDropTargetId = dropTargetId || dropTarget?.parent
  const dropTargetElement =
    typeof realDropTargetId === 'string' ? store.getItemTree(realDropTargetId) : undefined
  const dragTargetElement =
    typeof dragSourceId === 'string' ? store.getItemTree(dragSourceId) : undefined

  if (dragTargetElement?.data instanceof SmartView) return
  if (dragSource?.data instanceof SmartView) return

  if (!isChild(dragSourceId) && dragSource?.data && dropTargetElement) {
    await store.groupsApiMenuStore.onCreateTeamsGroupsByIdAddTeams(
      dragSource.data,
      dropTargetElement.data.id
    )

    return
  }

  if (!dropTargetElement || !dragTargetElement) return

  await store.groupsApiMenuStore.onCreateTeamsGroupsByIdAddTeams(
    dragTargetElement.data,
    dropTargetElement.data.id
  )
}
